import React, { Component } from 'react';
import SakuraOrbit from './SakuraOrbit';
import PageMeta from './PageMeta';
import SakuraSep from './SakuraSep';
import { Link } from 'react-router-dom';
import { DataRPC } from '../../rpc-client/DataRPC';
import { s3 } from '../../config/constants';

const rpc = new DataRPC();

const MONTH_ABBR = [
    'THG 1','THG 2','THG 3','THG 4','THG 5','THG 6',
    'THG 7','THG 8','THG 9','THG 10','THG 11','THG 12',
];

const parseDate = (dateStr) => {
    if (!dateStr) return { day: '--', month: '---', year: '----' };
    const d = new Date(dateStr + 'T00:00:00');
    return {
        day:   String(d.getDate()).padStart(2, '0'),
        month: MONTH_ABBR[d.getMonth()],
        year:  String(d.getFullYear()),
    };
};

const statusLabel = (startDate, endDate) => {
    const now   = new Date(); now.setHours(0, 0, 0, 0);
    const start = new Date(startDate + 'T00:00:00');
    const end   = endDate ? new Date(endDate + 'T00:00:00') : start;
    if (now < start) return { text: 'Sắp diễn ra', cls: 'fdet-badge--upcoming' };
    if (now <= end)  return { text: 'Đang diễn ra', cls: 'fdet-badge--ongoing'  };
    return             { text: 'Đã kết thúc',    cls: 'fdet-badge--done'     };
};

class FestivalDetail extends Component {
    state = { festival: null, loading: true, notFound: false };

    componentDidMount() {
        const { slug } = this.props.match.params;
        const isId = /^\d+$/.test(slug);
        rpc.fetchRawData('GetFestival1', isId ? { id: parseInt(slug, 10) } : { slug })
            .then(festival => {
                if (!festival || !festival.id) {
                    this.setState({ loading: false, notFound: true });
                } else {
                    this.setState({ festival, loading: false });
                }
            })
            .catch(() => this.setState({ loading: false, notFound: true }));
    }

    render() {
        const { festival, loading, notFound } = this.state;
        const showNotFound = !loading && (notFound || !festival);

        const s  = festival ? parseDate(festival.start_date) : null;
        const e  = festival ? parseDate(festival.end_date) : null;
        const st = festival ? statusLabel(festival.start_date, festival.end_date) : null;

        return (
            <>
                {festival && (
                    <PageMeta
                        title={festival.name}
                        description={festival.short_description || festival.name}
                        image={festival.banner_url ? s3(festival.banner_url) : undefined}
                        url={`/festival/${festival.slug || festival.id}`}
                    />
                )}

                {/* ── Hero banner ── */}
                <div
                    className="page-header fdet-header"
                >
                    <div className="page-header-overlay fdet-overlay" />
                    <div className="container page-header-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="entry-meta-date">Việt Nam Yosakoi Festival</div>
                                <h1 className="page-header-title">LỄ HỘI</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sep-gold-rule" style={{ margin: 0 }} />

                {/* ── Body ── */}
                <div className="fdet-body">
                    <div className="container">

                        {loading ? (
                            <div className="fdet-loading">
                                <SakuraOrbit label="Đang tải thông tin lễ hội" />
                            </div>
                        ) : showNotFound ? (
                            <div className="fdet-not-found">
                                <div className="fdet-not-found-kanji">祭</div>
                                <h2>Không tìm thấy lễ hội</h2>
                                <p>Lễ hội không tồn tại hoặc đã bị xóa.</p>
                                <Link to="/festival" className="nwd-back-btn">← Về Lễ Hội</Link>
                            </div>
                        ) : (
                            <>
                                <div className="entry-title">
                                    <p>{st.text}</p>
                                    <h2>CHI TIẾT SỰ KIỆN</h2>
                                </div>

                                <article className="fdet-article">
                                    {festival.avatar_url && (
                                        <div className="fdet-featured-img">
                                            <img src={s3(festival.avatar_url)} alt={festival.name} />
                                        </div>
                                    )}

                                    <div className="fdet-article-inner">
                                        <div className="fdet-meta-bar">
                                            {/* Date block */}
                                            <div className="fdet-meta-item">
                                                <div className="fdet-meta-label">Thời Gian</div>
                                                <div className="fdet-date-range">
                                                    <div className="fdet-date-box">
                                                        <span className="fdet-date-day">{s.day}</span>
                                                        <span className="fdet-date-month">{s.month}</span>
                                                        <span className="fdet-date-year">{s.year}</span>
                                                    </div>
                                                    {festival.end_date && festival.end_date !== festival.start_date && (
                                                        <>
                                                            <div className="fdet-date-arrow">→</div>
                                                            <div className="fdet-date-box">
                                                                <span className="fdet-date-day">{e.day}</span>
                                                                <span className="fdet-date-month">{e.month}</span>
                                                                <span className="fdet-date-year">{e.year}</span>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Location */}
                                            {festival.location && (
                                                <div className="fdet-meta-item">
                                                    <div className="fdet-meta-label">Địa Điểm</div>
                                                    <div className="fdet-meta-value fdet-location">
                                                        <i className="fas fa-map-marker-alt" /> {festival.location}
                                                    </div>
                                                </div>
                                            )}

                                            {/* Status */}
                                            <div className="fdet-meta-item">
                                                <div className="fdet-meta-label">Trạng Thái</div>
                                                <span className={`fdet-badge fdet-badge--lg ${st.cls}`}>{st.text}</span>
                                            </div>
                                        </div>

                                        {festival.short_description && (
                                            <p className="fdet-excerpt">{festival.short_description}</p>
                                        )}

                                        {festival.content ? (
                                            <div
                                                className="fdet-content"
                                                dangerouslySetInnerHTML={{ __html: festival.content }}
                                            />
                                        ) : (
                                            <div className="fdet-no-content">
                                                <span>祭</span>
                                                <p>Nội dung đang được cập nhật...</p>
                                            </div>
                                        )}
                                    </div>
                                </article>

                                <div className="fdet-footer-nav">
                                    <Link to="/festival" className="nwd-back-btn">← Về Lễ Hội</Link>
                                </div>
                            </>
                        )}

                        <SakuraSep />
                    </div>
                </div>

                <div className="sep-gold-rule" style={{ margin: 0 }} />
            </>
        );
    }
}

export default FestivalDetail;
